import React from "react";

const Background_1 = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 164 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.640625 0.935059H153.641V10.9351H163.641V11.9351H0.640625V0.935059Z"
      className="svg-fill"
    />
    <rect x="160.641" y="0.935059" width="3" height="3" className="svg-fill" />
    <rect x="156.641" y="5.93506" width="7" height="2" className="svg-fill" />
    <rect
      x="158.641"
      y="0.935059"
      width="7"
      height="2"
      transform="rotate(90 158.641 0.935059)"
      className="svg-fill"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.640625 12.0398H33.6406V36.0398H28.4317H22.4317H3.64062V33.0398V31.0398V28.0398H0.640625V12.0398ZM2.64062 31.0398H0.640625V33.0398H2.64062V31.0398Z"
      className="svg-fill"
    />
    <rect width="100" height="30" transform="translate(33.6406 12.0398)" className="svg-fill" />
    <path d="M163.641 12.0398H133.641V36.0398H163.641V12.0398Z" className="svg-fill" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M163.641 35.73H0.640625V35.9163V36.73L9.64062 45.73H67.5078H69.6406V40.73H94.6406V45.73H102.766H152.53L158.641 40.23V39.73H159.196L163.641 35.73Z"
      className="svg-fill"
    />
    <path
      d="M146.641 53.73L163.641 38.73L163.641 42.2621L150.607 53.73L146.641 53.73Z"
      className="svg-fill"
    />
  </svg>
);

export default Background_1;
